import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { RIBBON_SWEEP } from '@/lib/ribbonAttention';

export type RibbonAttention = { maxPerMove: number; restMs: number; urgentKeys: string[] };

/** Admin-tuned ribbon attention (desk_habit_settings). Falls back to the code defaults. */
export function useRibbonAttention(): RibbonAttention {
  const q = useQuery({
    queryKey: ['ribbon-attention'],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase.from('desk_habit_settings' as never)
        .select('sweep_rest_minutes, sweep_max_per_move, urgent_move_keys').maybeSingle();
      if (error) throw error;
      return data as unknown as { sweep_rest_minutes: number; sweep_max_per_move: number; urgent_move_keys: string[] } | null;
    },
  });
  const d = q.data;
  return {
    maxPerMove: d?.sweep_max_per_move ?? RIBBON_SWEEP.maxPerMove,
    restMs: d ? d.sweep_rest_minutes * 60_000 : RIBBON_SWEEP.restMs,
    urgentKeys: d?.urgent_move_keys ?? [],
  };
}
